import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import useCartStore from '../store/cartStore';

/**
 * Hook to extract and persist UTM parameters from URL
 */
export const useUtmParams = () => {
  const [searchParams] = useSearchParams();
  const setUtmParams = useCartStore((state) => state.setUtmParams);

  useEffect(() => {
    const utmParams = {
      utm_source: searchParams.get('utm_source') || undefined,
      utm_medium: searchParams.get('utm_medium') || undefined,
      utm_campaign: searchParams.get('utm_campaign') || undefined,
      utm_term: searchParams.get('utm_term') || undefined,
      utm_content: searchParams.get('utm_content') || undefined,
    };

    // Only set if at least one UTM param exists
    const hasUtmParams = Object.values(utmParams).some((value) => value !== undefined);

    if (hasUtmParams) {
      setUtmParams(utmParams);
      console.log('[UTM] Parameters captured:', utmParams);
    }
  }, [searchParams, setUtmParams]);
};
